import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import '../BookingJourney/AppointmentPage.css'
import { ChevronRight, ChevronDown, Phone } from "lucide-react";
import logo from "../../Assets/images/ldc_logo_new.png";
import Appointmenttype from "../Dashboard/Appointmenttype";
import BookingForm from "../Dashboard/BookingForm";
import ClinicBooking from "../Dashboard/ClinicBooking";
import PreferredTime from "../Dashboard/PreferredTime";
import { universalDummyData, mockAppointmentData, mockHealthScreenData, mockData } from '../BookingJourney/data';
import {getAllHealthScreenData} from './data';

import SecondStep from "./SecondStep";
import AppointmentSelectionHardcoded from "../BookingJourney/StepComponents/AppointmentSelectionHardcoded";
import Step4 from "../BookingJourney/StepComponents/Step4";
import axios from "axios";
import AppointmentSelection from "../Dashboard/AppointmentSelection";


const Hbooking = ({data,languageData,clinicId,clinicData}) => {
  // console.log("Hbooking::",data)
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(2);
  const [callbackData,setCallbackData] = useState();
  const [selectedHealthOption, setSelectedHealthOption] = useState(null);
    const [gpDuration, setGpDuration] = useState(false)
    const [gpLang, setGpLang] = useState(false)
    const [allClinics, setAllClinics] = useState({})
  const [combineAllClinicAndClinicById , setCombineAllClinicAndClinicById] = useState([])
    const [ showAppoinmentData,setShowAppoinmentData] = useState({})
    const [availableSlotsMetadata,setAvailableSlotsMetadata]=useState([])
    const [dataExists, setDataExists] = useState(false);
    const [loading,setLoading]=useState(true)
    const [prefanceData,setprefanceData ]=useState({})
    // appointmentSelection page 
    const [showAppoinmentDataDisplay, setshowAppoinmentDataDisplay] = useState(undefined)


  //3rd step type specification
  const [clinicBookingType, setClinicBookingType] = useState("");
    const [showAppointmentSelection, setShowAppointmentSelection] = useState(false);
  

   const fetchGpDuration = async () => {
     setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URLOPEN}appointment-duration`,
          {
            headers: {
              "Content-Type": "application/json"
            },
            params: {
              category: "clinician_type"
            }
          }
        );

        // need format like this 
            // Transform the array to an object with duration_id as key
        const formattedData = response.data.data.reduce((acc, item) => {
          acc[item.duration_id] = item;
          return acc;
        }, {});

        // setGpDuration(response.data);
        setGpDuration(formattedData);
        // console.log("Formatted Duration gp data:", formattedData);
      } catch (error) {
        console.error("Error fetching health screen data:", error);
      }
    };

     const fetchGpLanguage = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URLOPEN}languages`,
          {
            headers: {
              "Content-Type": "application/json"
            },
            params: {
              category: "clinician_type"
            }
          }
        );

        // need format like this 
            // Transform the array to desired format
        const formattedData = response.data.data.map(lang => ({
          label: lang.language_name,
          value: lang.language_id
        }));

        // setGpLang(response.data);
        setGpLang(formattedData);
        // console.log("Formatted health screen data:", formattedData);
      } catch (error) {
        console.error("Error fetching health screen data:", error);
      }
    };
    const fetchAllClinic = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URLOPEN}clinics`,
          {
            headers: {
              "Content-Type": "application/json"
            },
            params: {
              category: "clinician_type"
            }
          }
        );

        // need format like this 
            // Transform the array to desired format
        // const formattedData = response.data.data.map(lang => ({
        //   label: lang.language_name,
        //   value: lang.language_id
        // }));

        const formattedData = response.data.data.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});

        setAllClinics(response.data);
        setCombineAllClinicAndClinicById(formattedData)
        // setGpLang(formattedData);
        // console.log("Formatted health screen data:", formattedData);
      } catch (error) {
        console.error("Error fetching all clinic data:", error);
      }
       setLoading(false);
    };

  function secondCallback(testData,type) {
    setprefanceData(testData)
    setClinicBookingType(type);
    setCurrentStep(currentStep + 1);
    
  }

  const handleBack = () => {
    setCurrentStep(currentStep-1)
  };

  const handleContinueStep4 = () => {
  };

  let today = new Date();
  let year = today.getFullYear();

  const bookingDetails = {
    showAppoinmentData :{
      ...showAppoinmentData,
      price : callbackData?.info?.price || 0,
    },

    callbackData,
    date: callbackData?.date +year || "20 June, 2025",
    time: callbackData?.info.start_time,
    isProtected : false

    // "11:45",
  };
  const handleContinue = () => {
    setCurrentStep(currentStep +  1);
  };

  const callbackAppointmentSelection = (selectedSlot, type) => {
    setShowAppointmentSelection(false);
    setCurrentStep(currentStep + 1 )
  };

  //! step 1 dummy data start [getAllHealthScreenData]

  const callbackAppointment = (data, formType) => {
    setCallbackData(data);
    handleContinue();
  };

 

  //! step 1 dummy data end

  //! step 2 dummy data start [mockAppointmentData, mockHealthScreenData, mockData ]

  const mockCallbackBookingForm = (formData, type) => {

    // PreferredTimeclinic or  PreferredTime
    setClinicBookingType(type);
    setCurrentStep(3);
  };

  const mockCallBackForBackPage = (source) => {
    setCurrentStep(1);
  };

  //! step 2 dummy data end

  //! step 3 dummy data start [universalDummyData]
  const nonGroupId = data?.non_gp_product_id
  const productData = data?.productData
  const corporateData = data?.corporateData
  const callbackClinicBooking = (data, type) => {
    setDataExists(false)
     if( data?.selectedSlots.length > 0 ){ // enable only when we select slots 
      // Enable AppointmentSelectionHardcoded


      var showAppoinmnt = {
        "clinic": {
          "non_gp_product_id":nonGroupId || null,
            "productCategory": {
                "key": "health screen",
                "title": "Health screen",
                "product_category_id": 2,
                "description": "one-liner description",
                ok : "he all 223 ",
            }
        },
        "type": "TIME",
        selectedClinics: data.selectedClinics||showAppoinmentData.selectedClinics,
        selectedSlots: data.selectedSlots|| showAppoinmentData.selectedSlot,
        productData: productData,
        corporateData:corporateData,
        data : {
          allClinicDataByID : combineAllClinicAndClinicById,
          isProtected : false,
        }
    }

      setAvailableSlotsMetadata(showAppoinmnt)
      setShowAppointmentSelection(true);
    }


  };

     const callBackForbackpage = () => {
    var showAppoinmnt = {
        "clinic": {
          "non_gp_product_id":nonGroupId || null,
            "productCategory": {
                "key": "health screen",
                "title": "Health screen",
                "product_category_id": 2,
                "description": "one-liner description",
                ok : "he all 223 ",
            }
        },
        "type": "TIME",
        data : {
          allClinicDataByID : combineAllClinicAndClinicById,
          isProtected : false,
        }
    }
    setAvailableSlotsMetadata(showAppoinmnt)
    setDataExists(true)
  };

  const callBackForbackpageClinicBooking = (page) => {
    setCurrentStep(currentStep - 1 )
  };


  // Mock callback functions
  const callbackPreferredTime = (data, type) => {

    if( data?.selectedSlots.length > 0 ){ // enable only when we select slots 
      setShowAppointmentSelection(true);// Enable AppointmentSelectionHardcoded
    }
  };

  const callBackForbackpagePreferredTime = (page) => {
  };

  //! step 3 dummy data end

  useEffect(() => {
    window.scrollTo(0, 0);
  },[])

       // Initialize component with route state
  useEffect(() => {
    if (location?.state) {
      // setSelectedHealthOption(location?.state?.appointmentData);
    }
    var a =data
    
    a.isbackcheck=function Back() {
      data.isback()
    };
    setSelectedHealthOption(a)
   
      fetchGpDuration();
      fetchGpLanguage()
      fetchAllClinic()
  }, [location?.state]);

  useEffect(() => {
        //ready data for clinicBooking
        const formatDataForAppointment = {
          showAppoinmentData : {
            data:dataExists,
            non_gp_product_id:data?.non_gp_product_id || 7,
            clinic: {
              productCategory: {
                title: data?.productCategory?.title || "Health screen",
                ok : "he all 289",
                product_category_id: data?.productCategory?.product_category_id || 2,
                product_id: data?.non_gp_product_id,
                
              },
              productData: data?.productData,
              corporateData: data?.corporateData,
              non_gp_product_id:data?.non_gp_product_id  || null,
            },
            // gender: "male",
            // language: {
            //   label: "English",
            //   value: 1,
            // },
            // duration: 1,
          },
          data : {
            clinic : {
              "id": 40,
              "name": "City Medical Center",
              "latitude": clinicData?.latitude,
              "longitude": clinicData?.longitude,
              "address": "123 Medical St, London",
              "clinic_website_description": "<p>Modern medical facility</p>",
              "position": "Main Building"
          },
          // durationObjectById : {
          //   1: {duration: '15'},
          //   2: {duration: '30'}
          // },
            isProtected:false,
            allClinicData : allClinics, 
            allClinicDataByID : combineAllClinicAndClinicById,
            isProtected : false
          }
        }
        setShowAppoinmentData(formatDataForAppointment)
      }, [allClinics,combineAllClinicAndClinicById ])

  return (
    
    <div className="page-wrapper">
      {/* <header className="header">
        <div className="logo">
          <img src={logo} alt="Logo" className="logo-img" />
        </div>
        <div className=" desktop-only">
          <div className="header-link">
            <ChevronRight size={12} />
            <span>Book online</span>
          </div>
          <div className="contact-call">
            <ChevronRight size={12} />
            <span>Or call 020 3993 0813</span>
          </div>
        </div>
        <div className="mobile-only">
          <span className="phone-number">
            <Phone size={20} />
          </span>
          <button className="hamburger">☰</button>
        </div>
      </header> */}
      

      <main className="main">
        {/* {currentStep === 1 && <StepOne onContinue={handleContinue} />} */}
        {/* {currentStep === 1 && (
          <Appointmenttype
            getAllHealthScreenData={getAllHealthScreenData}
            callback={callbackAppointment}
            callBackForbackpage={callBackForbackpage}
            ContinueButoonStylingMiddle={true}
          />
        )} */}
        {/* {currentStep === 2 && (
          <BookingForm
            showAppoinmentData={mockAppointmentData}
            getAllHealthScreenData={mockHealthScreenData}
            data={mockData}
            callbackBookingForm={mockCallbackBookingForm}
            callBackForbackpage={mockCallBackForBackPage}
          />
        )} */}
        {currentStep === 2 && (
          <SecondStep
          //  data={callbackData} 
           data={selectedHealthOption} 
           languageData={languageData}
           secondCallback={secondCallback}
           loading={loading}
            // showAppoinmentData={mockAppointmentData}
            // getAllHealthScreenData={mockHealthScreenData}
            // data={mockData}
            // callbackBookingForm={mockCallbackBookingForm}
            // callBackForbackpage={mockCallBackForBackPage}           
           />
        )}
        {currentStep === 3 && (
          <>
            {/* // PreferredTimeclinic or  PreferredTime */}
            {clinicBookingType === "PreferredTimeclinic" && (
              // For ClinicBooking
              <ClinicBooking
              clinicId={clinicId}
              check={dataExists}
              prefanceData={prefanceData}
                showAppoinmentData={showAppoinmentData.showAppoinmentData}
                data={showAppoinmentData.data}
                metaData={availableSlotsMetadata}
                callback={callbackClinicBooking}
                callBackForbackpage={callBackForbackpageClinicBooking}
                getAllHealthScreenData={
                  universalDummyData.getAllHealthScreenData
                }
                // goback={()=>setCurrentStep(currentStep-1)}
                // getAllHealthScreenData={
                //   universalDummyData.getAllHealthScreenData
                // }
              />
            )}
            {clinicBookingType === "PreferredTime" && (
              // For PreferredTime
              <PreferredTime
              clinicId={clinicId}
              check={dataExists}
                showAppoinmentData={showAppoinmentData.showAppoinmentData}
                data={showAppoinmentData.data}
                prefanceData={prefanceData}
                metaData={availableSlotsMetadata}
                callback={callbackClinicBooking}
                callBackForbackpage={callBackForbackpagePreferredTime}
                goback={()=>setCurrentStep(currentStep-1)}
                getAllHealthScreenData={
                  universalDummyData.getAllHealthScreenData
                }
              />

            )}

             {/* {showAppointmentSelection && ( clinicBookingType === "PreferredTime" || clinicBookingType === "PreferredTimeclinic") &&(
              <>
                <AppointmentSelectionHardcoded 
                      onContinue={callbackAppointmentSelection}
                      onBack={() => setShowAppointmentSelection(false)}
                />
              </>
            )} */}


            { availableSlotsMetadata.selectedClinics && (
              <>
                {/* <AppointmentSelection */}
                <AppointmentSelection
                  showAppoinmentData={availableSlotsMetadata}
                  prefanceData={prefanceData}
                  // showAppoinmentData={appointmentDummy.showAppoinmentData}
                  data = {availableSlotsMetadata.data}
                  callback={callbackAppointment}
                  callBackForbackpage={callBackForbackpage}
                />
              </>
            )}
          </>
        )}

        {currentStep === 4 && ( 
                <Step4
                onBack={handleBack}
                onContinue={handleContinueStep4}
                bookingDetails={bookingDetails}
                showAppoinmentData={showAppoinmentData}
              />
        ) }


        
      </main>

      {/* <footer className="footer">
        <div className="logo">
          <img src={logo} alt="Logo" style={{ height: "40px" }} />
        </div>
      </footer> */}


    </div>
  );
};

export default Hbooking;
